import { render, staticRenderFns } from "./SidebarManagement.vue?vue&type=template&id=a8a6951a&scoped=true&"
import script from "./SidebarManagement.vue?vue&type=script&lang=js&"
export * from "./SidebarManagement.vue?vue&type=script&lang=js&"
import style0 from "./SidebarManagement.css?vue&type=style&index=0&id=a8a6951a&prod&scoped=true&lang=css&"
import style1 from "./SidebarManagementUnScoped.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a6951a",
  null
  
)

export default component.exports